const userCreditsFormat = value => {
    if (value % 1 === 0) {
        return value;
    }
    return parseFloat(value || 0).toFixed(2);
};

export default userCreditsFormat